import { Box } from '@primer/react';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';
import { TippyWithOriginalStyles } from '@upright/ui/common/generic/components/tooltips/default-tippy';
import { formatPercentage } from '@upright/ui/common/generic/utilities/format';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  name: string;
  benchmark: {
    name: ReactNode;
    explanation: ReactNode;
  };
  netsum: {
    explanation: ReactNode;
  };
  score: number;
  scores: number[];
}

export function Summary(props: Props) {
  const { name, score, scores } = props;
  const percentile = getPercentile(score, scores);

  return (
    <Box mb={3} color="text.muted" fontSize={[1, 1, 2]}>
      Out of the <Highlight explanation={props.benchmark.explanation}>{props.benchmark.name}</Highlight>,{' '}
      <b>{formatPercentage(percentile)}</b> have a lower{' '}
      <Highlight explanation={props.netsum.explanation}>net impact ratio</Highlight>&nbsp;than {name}.
    </Box>
  );
}

function Highlight(props: { children: ReactNode; explanation: ReactNode }) {
  return (
    <span>
      <TippyWithOriginalStyles
        trigger={'mouseenter focus'}
        appendTo={() => document.body}
        interactive={true}
        content={<Text color="fg.onEmphasis">{props.explanation}</Text>}
        placement="bottom"
      >
        <StyledUnderline>{props.children}</StyledUnderline>
      </TippyWithOriginalStyles>
    </span>
  );
}

const StyledUnderline = styled.span`
  cursor: help;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-position: under;
`;

function getPercentile(score: number, scores: number[]) {
  const p = scores.filter(value => value < score).length;
  const n = scores.length;
  return p / n;
}
